import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

const settings: AxiosRequestConfig = {
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
};

export const client: AxiosInstance = axios.create(settings);
